import {
  getUserInfo,
  logout,
} from "@/api/member";
// 登录与注册的模块
const state = {
  code: "",
  token: '',
  userInfo: {},
  lang: "" // 国际化语言
};
const mutations = {
  SET_TOKEN_PERSIST(state, token) {
    state.token = token;
  },
  SET_LANG_PERSIST(state, lang) {
    state.lang = lang;
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo;
  },
  // 清除本地数据
  CLEAR_TOKEN_PERSIST(state) {
    // 用户信息清空
    state.token = '';
    state.userInfo = {};
  },
};
const actions = {
  // 保存登录凭证
  setToken({ commit }, token) {
    commit("SET_TOKEN_PERSIST", token);
  },
  setLang({ commit }, lang) {
    commit("SET_LANG_PERSIST", lang);
  },
  setUserInfo({ commit }, userInfo) {
    commit("SET_USER_INFO", userInfo);
  },
  // 清除已过期的token
  clearToken({ commit }) {
    commit("CLEAR_TOKEN_PERSIST");
  },
  // 获取用户信息
  async getUserInfo({ commit }) {
    const result = await getUserInfo();
    if (result.httpCode === 200) {
      // 如果用户信息中没有手机号，则认为用户未登录
      if (!result.data.phone_number) {
        this.userLogout();
        return false;
      }
      // 提交用户信息
      commit("SET_USER_INFO", result.data);
      return 'ok';
    } else {
      console.log('用户未登录')
    }
  },
  // 退出登录
  async userLogout({ commit }) {
    const result = await logout();
    // action里面不能操作state，提交mutation修改state
    if (result.httpCode === 200) {
      commit("CLEAR_TOKEN_PERSIST");
      return 'ok';
    } else {
      return Promise.reject(new Error('faile'));
    }
  },
};
const getters = {};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
